import { createContext } from 'react'
import { IUIConfig } from '../data/interface'

export const UIConfigContext = createContext<{ loading: boolean, config: IUIConfig | null }>({
  loading: true,
  config: null
})